<template>
    <div class="dropdown">
        <!--<b>#{{item.id}}</b>-->
        <!--<i class="fa fa-file"></i>-->
        <a href="#" class="dropdown-item"><i class="fa fa-file"></i> {{ item.name }}</a>
        <!--<abbr>{{item.description}}</abbr>-->
    </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true }
  }
};
</script>
